<div class="modal-header">
  <h4 class="modal-title">
    @if(mode === 'deposit') {
      Agregar crédito
    } @else {
      Reembolsar crédito
    }
  </h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="activeModal.dismiss('Cross click')">
  </button>
</div>

<div class="modal-body">
  <form
    id="formHouseCredit"
    [formGroup]="form"
    (ngSubmit)="onSubmit()">
    <div class="container-fluid">
      <div class="row">

        <div class="col-12 mb-3 form-group">
          <label
            for="amount"
            class="form-label">
            Monto
            @if(mode === 'refund' && maxAmount != null) {
              <small class="text-muted">(máximo ${{ maxAmount | number:'1.2-2' }})</small>
            }
          </label>
          <input
            type="number"
            id="amount"
            class="form-control"
            formControlName="amount"
            placeholder="0.00"
            step="0.01"
            min="0.01"
            [ngClass]="{
              'is-invalid': submitted && formControls['amount'].errors
            }">
          <div
            *ngIf="submitted && formControls['amount'].errors"
            class="invalid-feedback">
            <div *ngIf="formControls['amount'].errors['required']">
              Por favor, ingrese el monto
            </div>
            <div *ngIf="formControls['amount'].errors['min']">
              El monto debe ser mayor a 0
            </div>
            <div *ngIf="formControls['amount'].errors['max']">
              El monto no puede superar el saldo disponible (${{ maxAmount | number:'1.2-2' }})
            </div>
          </div>
        </div>

        <div class="col-12 mb-3 form-group">
          <label
            for="notes"
            class="form-label">
            Notas
          </label>
          <textarea
            id="notes"
            class="form-control"
            formControlName="notes"
            rows="4"
            placeholder="Notas (Opcional)">
          </textarea>
        </div>

      </div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <div class="col-12 my-2">
    <button
      (click)="activeModal.close()"
      type="button"
      class="btn btn-outline-danger w-100">
      Cancelar
    </button>
  </div>
  <div class="col-12">
    <button
      type="submit"
      form="formHouseCredit"
      class="btn btn-primary w-100"
      [disabled]="saving">
      @if(saving) {
        <span
          class="spinner-border spinner-border-sm me-1"
          role="status">
        </span>
      }
      @if(mode === 'deposit') {
        Registrar depósito
      } @else {
        Registrar reembolso
      }
    </button>
  </div>
</div>
